import {Component, OnInit} from '@angular/core';
import {WebNavigationService} from '../../../navigation.service';
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-transfer-submenu',
  templateUrl: 'transfer-submenu.component.html',
  styleUrls: ['transfer-submenu.component.scss'],
})
export class TransferSubmenuComponent implements OnInit {

  constructor(private navigationService: WebNavigationService, private router: Router, private activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {
  }

  selectedTransferOption(transferOption) {

    switch(transferOption) {
      case 0:
        this.router.navigate(['abonoMonedero'], {relativeTo: this.activatedRoute});
        break;
      default:
        break;
    }

  }

  get selectedOption() {
    return this.navigationService.selectedOption;
  }

  get expanded() {
    return this.navigationService.expanded;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/navigation/options/transfers/submenu/transfer-submenu.component.ts